import React from 'react';
import { Card } from 'react-bootstrap';
import { BsCircleFill } from 'react-icons/bs';
import { commafy } from 'Utils';

const SensitiveItemBar = (props) => {
  return (
    <div 
      style={{
        width: '100%',
        height: '15px',
        borderRadius: '25px',
        background: '#EDEFF2',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          borderRadius: '25px 0 0 25px',
          background: '#315DFF',
          height: '100%',
          position: 'absolute',
          left: 0,
          width: `${Math.floor(props.sensitive / props.total * 100)}%`
        }}
      />
    </div>
  );
}

const FlaggedFieldSection = (props) => {
  return (
    <div className='h-100 d-flex flex-column justify-content-center' data-testid={`flagged-section-${props.label}`}>
      <div>
        <div style={{ fontSize: '12px', fontWeight: '500' }}>TOTAL {props.label}</div>
        <div 
          style={{ 
            fontSize: '16px',
            fontWeight: '500',
            color: '#315DFF'
          }}
        >
          {commafy(props.total)}
        </div>
      </div>
      <div>
        <SensitiveItemBar 
          sensitive={props.sensitive}
          safe={props.safe}
          total={props.total}
        />
      </div>
      <div style={{ fontSize: '12px' }} className='d-flex mt-3'>
        <div className='w-50'>
          <BsCircleFill className='mr-2' color='#315DFF' /> {' '}
          <span>
            <span
              style={{
                fontWeight: '500',
                color: '#315DFF'
              }}
            >
              {commafy(props.sensitive)}
            </span>
            {' '}
            <span>
              SENSITIVE
            </span>
          </span>
        </div>
        <div className='w-50'>
          <BsCircleFill className='mr-2' color='#D9DDE3' /> {' '}
          <span>
            <span
              style={{
                fontWeight: '500',
                color: '#315DFF'
              }}
            >
              {/* {commafy(props.safe)} */}
              { props.safe < 0 ? '0': commafy(props.safe)}
            </span>
            {' '}
            <span>
              SAFE
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}

const FlaggedFields = (props) => {
  return (
    <div className='h-100 d-flex flex-column'>
      <div>
        <h5 className='text-left sg-eyebrow'>Findings by quantity</h5>
      </div>
      <Card className='flex-grow-1 w-100 d-flex flex-column justify-content-center pt-4 pb-4 pl-2 pr-2'>
        <div className='h-50 d-flex flex-column justify-content-center mb-1'>
          <FlaggedFieldSection
            label={(props.nomenclature?.item || (props.isFileBased ? 'files' : 'tables')).toUpperCase()}
            total={props.totalTables}
            sensitive={props.sensitiveTables}
            safe={props.totalTables - props.sensitiveTables}
          />
        </div>
        <div className='h-50 d-flex flex-column justify-content-center mt-1'>
          <FlaggedFieldSection
            label='FIELDS'
            total={props.totalColumns}
            sensitive={props.sensitiveColumns}
            safe={props.totalColumns - props.sensitiveColumns}
          />
        </div>
      </Card>
    </div>
  );
}

export default FlaggedFields;